import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getTabs } from "store/selectors/tabsSettings";
import { ColorConditionService } from "utils/services/colorCondition.service";

const useCellColor = (props) => {
  const { columnId, cellValue, rowData, tableData } = props;
  const currentTabId = 1;

  const defaultColor = "#000"

  const tabSetting = useSelector(getTabs)?.[currentTabId] ?? null;

  const { colorScheme, uniqueColorsData } = useMemo(() => {
    return tabSetting?.[columnId] ?? { colorScheme: null, uniqueColorsData: null };
  }, [columnId, tabSetting])
  if (!colorScheme) {
    return defaultColor;
  }

  const colorData = ColorConditionService.getColorByColorScheme({
    colorScheme: colorScheme,
    uniqueColorsData: uniqueColorsData,
    tableData: tableData,
    currentValue: cellValue,
  });

  return colorData?.color ?? defaultColor;
};

export default useCellColor;
